import styled from 'styled-components';

export const Wrapper = styled.svg`
position: relative;
margin-right: 10px;
width: 20px;
&.search-load {
  height: 20px;
  display: inline-block;
  position: absolute;
  top: 10px;
  right: 5px;
  float: right;
}

&.btn-load {
  height: 10px;
  float: left:
}
`;

export const StyledSpinner = styled.svg`
animation: rotate 2s linear infinite;
margin: -25px 0 0 -25px;
width: 5px;
height: 5px;

.path {
  stroke: rgba(0, 0, 0, 1.0);
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
`;


// WEBPACK FOOTER //
// ./src/components/common/Loader/Styled.js